import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import SignUp from './SignUp.jsx';

const rootElement = document.getElementById('REACT_proUserSignUp');

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <Sentry.ErrorBoundary>
      <SignUp />
    </Sentry.ErrorBoundary>
  );
}
